import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { editStateSupplyAlertProfile } from "../atoms/atoms";
import { ISupplyAlertProfile } from "../types";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";

export const SupplyAlertProfileDetails = (props: {
    setChanges: React.Dispatch<React.SetStateAction<boolean>>;
    data: ISupplyAlertProfile | undefined;
}) => {
    // Props drilled
    const { data, setChanges } = props;

    // Recoil Hook
    const edit = useRecoilValue(editStateSupplyAlertProfile);

    // Form Functions
    const { register } = useFormContext();
    const formMethods = useFormContext();

    // Local Hooks
    const [inputData, setInputData] = useState(data?.supplyAlertProfileName || "");
    const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

    return (
        <>
            <div className="bg-bgDB">
                <div className="m-2 bg-white box-shadow h-full">
                    <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
                        <div className="col-span-2 my-1">
                            <TextInputLabelHookForm
                                name="supplyAlertProfileName"
                                label="Supply Alert Profile Name"
                                type="text"
                                onChange={(e) => {
                                    setInputData(e.target.value.trim());
                                    e.target.value = e.target.value.replace(/\s+/g, " ");

                                    if (
                                        e.target.value.trim() === "" ||
                                        (e.target.value.trim() === data?.supplyAlertProfileName &&
                                            checkBoxChanges === data?.isActive)
                                    ) {
                                        setChanges(false);
                                    } else {
                                        setChanges(true);
                                    }
                                }}
                                required={true}
                                className={
                                    formMethods.formState.errors.supplyAlertProfileName &&
                                    formMethods.formState.errors.supplyAlertProfileName.message &&
                                    "border-2 border-red-500 col-span-2 "
                                }
                                register={formMethods.register("supplyAlertProfileName", {
                                    required: {
                                        value: true,
                                        message: "Required Field",
                                    },
                                })}
                                maxLength={255}
                            />
                        </div>

                        {edit && (
                            <div className="col-span-2 my-1">
                                <CheckBoxLabelHookForm
                                    name="isActive"
                                    label={
                                        checkBoxChanges
                                            ? "Uncheck to Deactivate"
                                            : "Check to Activate"
                                    }
                                    type="checkbox"
                                    validation={{
                                        required: {
                                            value: false,
                                            message: "Required Field",
                                        },
                                    }}
                                    onClick={(e) => {
                                        setCheckBoxChanges(e.target.checked);
                                        if (
                                            inputData?.trim() === "" ||
                                            (e.target.checked === data?.isActive &&
                                                inputData === data?.supplyAlertProfileName)
                                        ) {
                                            setChanges(false);
                                        } else {
                                            setChanges(true);
                                        }
                                    }}
                                    register={register}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SupplyAlertProfileDetails;
